import React, { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import Base, { Breadcrumbs } from '../../layout';
import CreateUpdateUser from '../../components/user.form';

const CreateUpdateUserAccount = () => {
    let { id } = useParams();
    const [isEdit, setIsEdit] = useState(false);
    useEffect(() => {
        if (id != 0) {
            setIsEdit(true);
        } else {
            setIsEdit(false);
        }
    }, []);

    //TODO: optimize code and key prevention
    return (
        <Base>
            <Breadcrumbs title={isEdit ? 'Edit User' : 'New User'} />
            <div className="row">
                <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
                    <div className="block">
                        <div className="block-title">
                            <h2>User Account</h2>
                        </div>

                        <CreateUpdateUser isOrganizationUser={false} />

                        <div id="modal-terms" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3 className="modal-title text-center">
                                            <strong>Terms and Conditions</strong>
                                        </h3>
                                    </div>
                                    <div className="modal-body">
                                        <h4 className="page-header">
                                            1. <strong>General</strong>
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultrices,
                                            justo vel imperdiet gravida, urna ligula hendrerit nibh, ac cursus nibh
                                            sapien in purus. Mauris tincidunt tincidunt turpis in porta. Integer
                                            fermentum tincidunt auctor.
                                        </p>
                                        <h4 className="page-header">
                                            2. <strong>Account</strong>
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultrices,
                                            justo vel imperdiet gravida, urna ligula hendrerit nibh, ac cursus nibh
                                            sapien in purus. Mauris tincidunt tincidunt turpis in porta. Integer
                                            fermentum tincidunt auctor.
                                        </p>
                                        <h4 className="page-header">
                                            3. <strong>Service</strong>
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultrices,
                                            justo vel imperdiet gravida, urna ligula hendrerit nibh, ac cursus nibh
                                            sapien in purus. Mauris tincidunt tincidunt turpis in porta. Integer
                                            fermentum tincidunt auctor.
                                        </p>
                                        <h4 className="page-header">
                                            4. <strong>Payments</strong>
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultrices,
                                            justo vel imperdiet gravida, urna ligula hendrerit nibh, ac cursus nibh
                                            sapien in purus. Mauris tincidunt tincidunt turpis in porta. Integer
                                            fermentum tincidunt auctor.
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <div className="text-center">
                                            <button
                                                type="button"
                                                className="btn btn-effect-ripple btn-primary"
                                                data-dismiss="modal">
                                                I&aposve read them!
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Base>
    );
};
export default CreateUpdateUserAccount;
